import managerMutations from './manager.mutation';
import managerStates from './manager.state';
import managerActions from './manager.action';
import managerGetters from './manager.getters';

export default {
  mutations: managerMutations,
  state: managerStates,
  actions: managerActions,
  getters: managerGetters
};
